import {
  LoadCustomerDPsAction,
  CustomerDPsLoadedAction,
  CustomerDPErroredAction,
  CustomerDPCsvErroredAction,
} from './admin-customer-dp.action';
import { AdminCustomerDPApiError } from './admin-customer-dp.errors';
import { createReducer, on } from '@ngrx/store';
import { CustomerDP } from '../../admin/models/customer-dp.model';

export interface AdminCustomerDPState {
  customerDPs: CustomerDP[];
  loaded: boolean;
  apiError: AdminCustomerDPApiError;
}

export const initialState: AdminCustomerDPState = {
  customerDPs: [],
  loaded: false,
  apiError: null,
};

export const adminCustomerDPReducer = createReducer(
  initialState,
  on(LoadCustomerDPsAction, (state) => ({
    ...state,
    apiError: null,
    customerDPs: [],
    loaded: false,
  })),
  on(CustomerDPsLoadedAction, (state, { customerDPs }) => ({
    ...state,
    apiError: null,
    customerDPs,
    loaded: true,
  })),
  on(CustomerDPErroredAction, (state, { error }) => ({ ...state, apiError: error })),
  on(CustomerDPCsvErroredAction, (state, { error }) => ({ ...state, apiError: error })),
);
